module.exports = __webpack_public_path__ + "img/logo黑.b8654509.png";